const translation = {
  en: {
    h1: 'IT Skills',
    h2: `Technologies experience`,
    title: 'IT skills and programming languages - Daniel Domínguez',
    levels_explained: 'Experience Level',
    wordLevel: ['Basic', 'Elementary', 'Intermediate', 'Advanced', 'Expert'],
    help_l1: 'Theory and basic practice with classic examples.',
    help_l2: 'Used at least in one real project.',
    help_l3: 'Used in some projects. Decent skill for most use cases.',
    help_l4: 'Used for years. Big confidence and advanced knowledge.',
    help_l5: 'Absolute Mastery. Many years working with it.',
    blinking: 'Orange',
    help_blinking: `Blinking means it's used within the last two years.`,
    tap_skill: `Tap the skill for +INFO`,
    languages: 'Languages / Engines / Services',
    frameworks: 'Frameworks / Libraries',
    other_tools: 'Tools / Programs',
    other_concepts: 'Other Concepts',
    future_skills: `Have my attention`,
  },
  es: {
    h1: 'Tecnologías IT',
    h2: 'Experiencia en skills de programación',
    title: 'Dominio de tecnologías y lenguajes - Daniel Domínguez',
    levels_explained: 'Nivel de experiencia',
    wordLevel: ['Básico', 'Moderado', 'Intermedio', 'Avanzado', 'Experto'],
    help_l1: 'Teoría y algo de práctica con ejemplos típicos.',
    help_l2: 'Se utilizó al menos en un proyecto real.',
    help_l3:
      'Uso en varios proyectos. Nivel aceptable para la mayoría de casos.',
    help_l4: 'Uso durante años. Se tiene confianza y conocimiento avanzado.',
    help_l5: 'Control absoluto. Te han salido canas de los años usando la herramienta (Normalmente cambias antes).',
    blinking: 'Naranja',
    help_blinking: `En naranja, significa que se utilizó en los últimos dos años.`,
    tap_skill: `Click la skill para +INFO`,
    languages: 'Lenguajes / Engines / Servicios',
    frameworks: 'Frameworks / Librerías',
    other_tools: 'Herramientas / Programas',
    other_concepts: 'Otros conceptos',
    future_skills: 'Me llaman la atención',
  },
}

export default translation
